<template>
    <div class="container" style="margin-top: 90px;">
        <button @click="getToken('hod')" type="button" class="btn btn-primary btn-sm me-2">HOD</button>
        <button @click="getToken('dean')" type="button" class="btn btn-primary btn-sm me-2">Dean</button>
        <button @click="getToken('panel')" type="button" class="btn btn-primary btn-sm me-2">Panel</button>
        <button @click="getToken('assessor')" type="button" class="btn btn-primary btn-sm me-2">Assessor</button>
        <button @click="getToken('external')" type="button" class="btn btn-primary btn-sm me-2">External</button>
        <div class="mt-5 mx-5" style="word-wrap: break-word;">
            ?token={{ token.token }}
        </div>
    </div>
</template>
<script>
import DataService from '../services/dataservice';

export default {
    name: 'generate',
    emits: ['toggleLoader'],
    data() {
        return {
            token: 'hello'
        }
    },
    methods: {
        async getToken(certifier) {
            this.$emit('toggleLoader');

            this.token = await DataService.generateToken(certifier)

            this.$emit('toggleLoader');
        }
    }
}
</script>